import { render, staticRenderFns } from "./NotificationLegend.vue?vue&type=template&id=f4d47dd8"
import script from "./NotificationLegend.vue?vue&type=script&lang=js"
export * from "./NotificationLegend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports